import React from 'react';
import { useWorkspace } from '../Context/WorkspaceContext';
import { FiUsers, FiDatabase, FiGlobe, FiZap, FiCalendar } from 'react-icons/fi';
import { useLanguage } from '../Context/LanguageContext';
import { WorkspaceInfoPanelSkeleton } from './SkeletonLoaders';
import './WorkspaceInfoPanel.css';

const WorkspaceInfoPanel = () => {
  const { workspaceData, loading: workspaceLoading } = useWorkspace();
  const { t } = useLanguage();

  // Format creation date using native JavaScript
  const formatCreationDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    } catch (error) {
      return dateString;
    }
  };

  if (workspaceLoading || !workspaceData) {
    return <WorkspaceInfoPanelSkeleton />;
  }

  return (
    <div className='info-panel'>
      <div className='info-panel-header'>
        <div className='info-panel-title'>
          {workspaceData.name}
        </div>
        <div className='info-panel-created'>
          <FiCalendar className="info-created-icon" size={12} />
          <span>{t('components.workspaceinfopanel.created')} {formatCreationDate(workspaceData.created_at)}</span>
        </div>
      </div>

      <div className="info-panel-stats">
        <div className="info-stat-item">
          <div className="info-stat-content">
            <div className="info-stat-icon">
              <FiUsers size={16} />
            </div>
            <div className="info-stat-details">
              <div className="info-stat-label">{t('components.workspaceinfopanel.members')}</div>
              <div className="info-stat-value">
                {workspaceData.workspace_member_count || 0} / {workspaceData.workspace_member_count_limit?.toLocaleString() || '∞'}
              </div>
            </div>
          </div>
        </div>

        <div className="info-stat-item">
          <div className="info-stat-content">
            <div className="info-stat-icon">
              <FiZap size={16} />
            </div>
            <div className="info-stat-details">
              <div className="info-stat-label">{t('components.workspaceinfopanel.credits')}</div>
              <div className="info-stat-value">
                {workspaceData.workspace_message_count_limit
                  ? (workspaceData.workspace_message_count || 0).toLocaleString()
                  : '∞'}
              </div>
            </div>
          </div>
        </div>

        <div className="info-stat-item">
          <div className="info-stat-content">
            <div className="info-stat-icon">
              <FiDatabase size={16} />
            </div>
            <div className="info-stat-details">
              <div className="info-stat-label">{t('components.workspaceinfopanel.characters')}</div>
              <div className="info-stat-value">
                {(workspaceData.workspace_character_count || 0).toLocaleString()} / {workspaceData.workspace_character_count_limit?.toLocaleString() || '∞'}
              </div>
            </div>
          </div>
        </div>

        <div className="info-stat-item">
          <div className="info-stat-content">
            <div className="info-stat-icon">
              <FiGlobe size={16} />
            </div>
            <div className="info-stat-details">
              <div className="info-stat-label">{t('components.workspaceinfopanel.urlsScraped')}</div>
              <div className="info-stat-value">
                {workspaceData.workspace_crawl_url_count || 0} / {workspaceData.workspace_crawl_url_count_limit?.toLocaleString() || '∞'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceInfoPanel;